import { RootState } from '../../../store'
import { connect, ConnectedProps } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  createBill,
  exportBillableCsv,
  getBillablePatient,
  getBillableSummary,
  getBilling,
} from '../actions'
import BillingComponent from '../components/BillingComponent'
import { BillStatus } from '../services'

const mapStateToProps = (state: RootState) => {
  return {
    isLogged: state.authReducer.isLogged,
    homeData: state.homeDataReducer,
    billablePatient: state.billingReducer.billablePatient,
    billableSummary: state.billingReducer.billableSummary,
    pagination: state.billingReducer.pagination,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getBilling: (size: number, page: number) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(getBilling(size, page, resolve, reject))
      })
    },
    getBillableSummary: () => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(getBillableSummary(resolve, reject))
      })
    },
    getBillablePatient: (
      page: number,
      limit: number,
      status: BillStatus,
      search: string,
    ) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(
          getBillablePatient(page, limit, status, search, resolve, reject),
        )
      })
    },
    exportBillableCsv: (search: string) => {
      return new Promise<Blob>((resolve: any, reject: any) => {
        dispatch(exportBillableCsv(search, resolve, reject))
      })
    },
    createBill: (patientId: number) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(createBill(patientId, resolve, reject))
      })
    },
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps)

export type PropsFromReduxBilling = ConnectedProps<typeof connector>

export default withRouter(connector(BillingComponent))
